module.exports = "/fonts/vendor/vue-pdf-app/dist/icons/pdf.woff2?6a9f5e4b044e436823f30d724c6c62c0";